"use client";

import { decodeAudioArrayBuffer } from "@/utils/audio/decodeAudioArrayBuffer";
import { encodeToOpusOrWavFile } from "@/utils/audio/encodeToOpusOrWavFile";

const RECORDED_AUDIO_BASE_NAME = "recorded-audio";
// Transparent for speech and singing at full bandwidth; this is also the codec Chrome used for the raw recording, so nothing is lost versus uploading it as-is
const RECORDING_OPUS_BITRATE_BPS = 64000;

// MediaRecorder stamps packets with wall-clock time, so whenever the mic delivers no frames for a while (Bluetooth headset switching profiles, OS-level mute, a throttled tab) the WebM/MP4 timeline keeps running with no audio behind it. Header-based measurement then reports the timeline length while the AI backend counts decoded samples, and the mismatch fails the conversion. Decoding in the browser and re-encoding makes header length and sample count the same number by construction. The upload keeps the decoded buffer's sample rate (the AudioContext rate, 44.1 or 48 kHz) and channel count rather than the pitch clip's 16 kHz mono, so no quality is lost.
export const convertRecordingToUploadFile = async (
  recordingBlob: Blob
): Promise<{ uploadFile: File; decodedDurationS: number }> => {
  const audioBuffer = await decodeAudioArrayBuffer(
    await recordingBlob.arrayBuffer()
  );

  const uploadFile = await encodeToOpusOrWavFile({
    audioBuffer,
    baseFileName: RECORDED_AUDIO_BASE_NAME,
    targetFormat: null,
    bitrate: RECORDING_OPUS_BITRATE_BPS,
  });

  // The decoded duration is the audio the mic actually delivered; the recorder compares it with the elapsed recording time to detect a mic that went silent mid-take
  return { uploadFile, decodedDurationS: audioBuffer.duration };
};
